import { getFeatureParam, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_PHONE_BROWSER, IS_PUBLIC } from 'reactApp/appHelpers/configHelpers';
import { RootState, store as reduxStore } from 'reactApp/store';

import { FeatureVariants, TemplateVariantString } from './features.types';

export const MAX_PARALLEL_UPLOAD_COUNT = getFeatureParam('upload-parallel', 'count', 1);
export const MAX_SIZE_FOR_WASM_HASH_LIB = getFeatureParam('wasm-hash-size', 'maxSize', 0);
export const FILE_READ_BLOCK_LENGTH = getFeatureParam('uploader-file-block', 'size', 20 * 1024 * 104);
export const isUploadResumeAvailabe = !IS_PUBLIC && !IS_PHONE_BROWSER && isFeature('upload-resumable');

export const isToggleFeature = <T extends boolean | TemplateVariantString, V>(
    variants: FeatureVariants<T, V>,
    result: T
): variants is FeatureVariants<boolean, V> => typeof result === 'boolean';

export const isMultiVariantFeature = <T extends boolean | TemplateVariantString, V>(
    variants: FeatureVariants<T, V>,
    result: T
): variants is FeatureVariants<TemplateVariantString, V> => typeof result !== 'boolean';

export const isMultiVariantFeatureResult = (result: boolean | TemplateVariantString): result is TemplateVariantString =>
    typeof result !== 'boolean';

export const chooseVariant = <T extends boolean | TemplateVariantString, V = any>(
    selector: (state: RootState) => T,
    variants: FeatureVariants<T, V> & { control: V }
): (() => V) => {
    return () => {
        const result = selector(reduxStore.getState());

        const { control, ...restVariants } = variants;

        /**
         * TS не справляется с деструктуризацией(...restVariants) и не хочет поверить, что
         * Omit<FeatureVariants<T, V> & { control: V; }, "control"> это тоже самое, что FeatureVariants<T, V>
         */
        const _variants = restVariants as unknown as FeatureVariants<T, V>;

        if (isToggleFeature(_variants, result)) {
            return result && _variants.variant1 ? _variants.variant1 : control;
        }

        if (isMultiVariantFeature(_variants, result) && isMultiVariantFeatureResult(result)) {
            const selected = _variants[result];

            return selected ?? control;
        }

        return control;
    };
};
